import { DataSourcesQueries } from '@frontend/api-data-sources';
import { ScheduleFFHelpers } from '@frontend/schedule-helpers';

export const useGetWaitlistFeatureFlagDetails = () => {
  const waitlistFFInfo = ScheduleFFHelpers.useWaitlistFeatureFlag();
  const directSchedulingFFInfo = ScheduleFFHelpers.useWaitlistDirectSchedulingFeatureFlag();

  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const isLoading = waitlistFFInfo.isLoading || directSchedulingFFInfo.isLoading || isLoadingIntegrationDetails;

  const isWaitlistDirectBookingEnabled =
    waitlistFFInfo.isEnabled && directSchedulingFFInfo.isEnabled && !isIntegratedOffice;

  return {
    isLoading,
    isWaitlistFFEnabled: waitlistFFInfo.isEnabled,
    isWaitlistDirectBookingEnabled,
  };
};
